export default __webpack_public_path__ + "static/screen-location-a038c6acb564500917e1ee4a4b4805e3.webp";